export default function releaseStage() {
  return window.location.href.indexOf('www') !== -1 ? 'production' : 'staging';
}
